import {api, CompanyDto} from '../../../global/api';

export const getCurrentCompany = async (companyId: string): Promise<CompanyDto | null> => {
  let page = 0;

  while (true) {
    const {data} = await api.companies.getCompanies({companyId, page, size: 100});
    const company = data.content?.find((item) => item.id === companyId);
    if (company) return company;

    page += 1;
    if (!data.content?.length || data.last || page >= (data.totalPages ?? 1)) return null;
  }
};
